import Placeholder from "../Placeholder";
import useMobileDevice from "../../../hooks/useMobileDevice";

function ProductListPlaceholder() {
  const { isMobile } = useMobileDevice();
  return (
    <div className="col-md-4 col-6 product-margin-mb">
      <div className="product-box">
        <div className="product-image mt-20">
          <Placeholder variant="rectangle" height={isMobile ? "207px" : "312px"} />
        </div>

        <div className="product-text mt-20">
          <h3>
            <Placeholder variant="text" width="50%" className="mx-auto" />
          </h3>
          <p className="desc truncate">
            <Placeholder variant="text" />
          </p>
          <p className="d-flex justify-content-center align-items-center">
            <Placeholder
              variant="text"
              width="35%"
              style={{ marginRight: "5px" }}
            />
            <Placeholder
              variant="text"
              width="35%"
              style={{ marginLeft: "5px" }}
            />
          </p>

          <Placeholder variant="rectangle" height="50px" />
        </div>
      </div>
    </div>
  );
}

export default ProductListPlaceholder;
